(() => {
  const selector = '.ih-original-myndlift';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeVideos = new Set();
  const seenVideos = new WeakSet();
  const visible = new WeakMap();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      const onScreen = entry.isIntersecting && entry.intersectionRatio > .2 && video.getClientRects().length > 0 && getComputedStyle(video).visibility !== 'hidden' && !video.closest('[data-ih-original-app-panel][aria-hidden="true"]');
      visible.set(video, onScreen);
      if (!onScreen || document.hidden || reduced.matches) video.pause();
      else if (video.dataset.ihMyndliftAutoplay === 'true') {
        video.muted = true;
        const play = video.play();
        if (play && play.catch) play.catch(() => {});
      }
    });
  }, {threshold: [0, .2]}) : null;
  const routes = [
    ['For individuals','/pages/myndlift-individuals'],
    ['For clinicians','/pages/myndlift-clinicians'],
    ['Reviews','/pages/myndlift-reviews'],
    ['How it works','/pages/myndlift-how-it-works'],
    ['Science','/pages/myndlift-science'],
    ['Brain Snapshots','/pages/myndlift-snapshots'],
    ['Guide to Brainwaves','/pages/myndlift-brainwaves'],
    ['FAQs','/pages/myndlift-faq'],
    ['Peak performance','/pages/myndlift-peak-performance']
  ];
  const toggle = node => {
    const isOpen = node.getAttribute('aria-expanded') !== 'true';
    node.setAttribute('aria-expanded', String(isOpen));
    node.classList.toggle('ih-is-open', isOpen);
    if(node.dataset.ihOriginalExpand){node.classList.toggle('hover',isOpen);}
    const answer = node.querySelector('[data-ih-original-answer]');
    if (answer) answer.hidden = !isOpen;
  };
  const showVideo = (source, title) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'ih-myndlift-video-dialog';
    dialog.style.cssText = 'border:0;border-radius:24px;padding:20px;background:#161819;color:#fff;width:min(1000px,92vw);max-height:90vh';
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label','Close video');
    close.style.cssText = 'display:block;margin:0 0 12px auto;border:0;border-radius:50%;background:#fff;color:#161819;width:36px;height:36px;font-size:25px;cursor:pointer';
    const video = document.createElement('video');
    video.src = source;
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('aria-label',title || 'Original Myndlift customer experience');
    video.style.cssText = 'display:block;width:100%;max-height:74vh;object-fit:contain;border-radius:12px';
    dialog.append(close, video);
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {video.pause();dialog.remove();});
    dialog.showModal();
    const play = video.play();
    if (play && play.catch) play.catch(() => {});
  };
  const activateApp = (container, selected, autoplay = false) => {
    container.querySelectorAll('[data-ih-original-app-tab]').forEach(tab=>tab.setAttribute('aria-selected',String(tab.dataset.ihOriginalAppTab===selected)));
    container.querySelectorAll('[data-ih-original-app-panel]').forEach(panel=>{
      const active=panel.dataset.ihOriginalAppPanel===selected;
      panel.setAttribute('aria-hidden',String(!active));panel.style.opacity=active?'1':'0';panel.style.visibility=active?'visible':'hidden';panel.style.pointerEvents=active?'auto':'none';
      panel.querySelectorAll('video').forEach(video=>{if(!active)video.pause();else if(autoplay&&!reduced.matches){video.muted=true;const play=video.play();if(play&&play.catch)play.catch(()=>{});}});
    });
  };
  const prepare = scope => {
    scope.querySelectorAll(selector+' [data-ih-original-app-tabs]').forEach(container=>activateApp(container,'Brain snapshots'));
    scope.querySelectorAll(selector+' nav[data-framer-name="Mobile closed"] [data-framer-name="Close"]').forEach(node=>{node.dataset.ihMobileMenuToggle='true';node.setAttribute('role','button');node.tabIndex=0;node.setAttribute('aria-label','Open navigation');node.setAttribute('aria-expanded','false');});
    scope.querySelectorAll(selector + ' video').forEach(video => {
      if (seenVideos.has(video)) return;
      seenVideos.add(video);
      activeVideos.add(video);
      video.controls = true;
      video.playsInline = true;
      video.autoplay = false;
      if (observer) observer.observe(video);
    });
    scope.querySelectorAll(selector + ' [data-framer-name="Unclicked"]').forEach(node => {
      node.dataset.ihOriginalGoal = 'true';node.setAttribute('role','button');node.tabIndex = 0;node.setAttribute('aria-pressed','false');
    });
    scope.querySelectorAll(selector + ' [data-framer-name="Learn"], '+selector+' [data-framer-name="Closed"]').forEach(node => {
      if(node.dataset.framerName!=='Learn' && node.textContent.trim()!=='Learn')return;
      if (node.querySelector('.ih-myndlift-menu-panel')) return;
      node.dataset.ihMenuTrigger = 'true';node.tabIndex = 0;node.setAttribute('role','button');node.setAttribute('aria-expanded','false');
      const panel = document.createElement('div');panel.className = 'ih-myndlift-menu-panel';panel.hidden = true;
      routes.slice(3).forEach(([label, href]) => {const a = document.createElement('a');a.textContent = label;a.href = href;panel.append(a);});
      node.append(panel);
    });
    scope.querySelectorAll(selector + ' [data-framer-name="Neuro Coaches"] [style], ' + selector + ' [data-framer-name="Myndlift reviews"] [style]').forEach(node => {
      if (!node.querySelectorAll('img').length || node.children.length < 3) return;
      if (!/(overflow:\s*(?:hidden|scroll|auto))/.test(node.getAttribute('style') || '')) return;
      if (node.scrollWidth <= node.clientWidth + 20) return;
      node.dataset.ihOriginalCarousel = 'true';
      if (node.nextElementSibling && node.nextElementSibling.classList.contains('ih-myndlift-carousel-controls')) return;
      const controls = document.createElement('div');controls.className = 'ih-myndlift-carousel-controls';
      ['‹','›'].forEach((label, index) => {const button = document.createElement('button');button.type = 'button';button.textContent = label;button.setAttribute('aria-label',index ? 'Next cards' : 'Previous cards');button.addEventListener('click',()=>node.scrollBy({left:(index ? 1 : -1)*Math.max(260,node.clientWidth*.7),behavior:reduced.matches?'auto':'smooth'}));controls.append(button);});
      node.after(controls);
    });
  };
  document.addEventListener('click', event => {
    const root = event.target.closest(selector);
    if (!root) return;
    const appTab=event.target.closest('[data-ih-original-app-tab]');
    if(appTab){const container=appTab.closest('[data-ih-original-app-tabs]');if(container)activateApp(container,appTab.dataset.ihOriginalAppTab,true);return;}
    const mobile=event.target.closest('[data-ih-mobile-menu-toggle]');
    if(mobile){const nav=mobile.closest('nav');const open=mobile.getAttribute('aria-expanded')!=='true';mobile.setAttribute('aria-expanded',String(open));mobile.setAttribute('aria-label',open?'Close navigation':'Open navigation');nav.classList.toggle('ih-is-mobile-open',open);nav.classList.toggle('framer-v-1huj5fr',open);nav.classList.toggle('framer-v-1bu43zx',!open);return;}
    const movie = event.target.closest('[data-ih-review-video]');
    if (movie && !event.target.closest('video')) {event.preventDefault();showVideo(movie.dataset.ihReviewVideo,movie.dataset.framerName);return;}
    const accordion = event.target.closest('[data-ih-original-accordion], [data-ih-original-expand]');
    if (accordion && !event.target.closest('a,video,button,input')) {toggle(accordion);return;}
    const goal = event.target.closest('[data-ih-original-goal]');
    if (goal) {event.preventDefault();const label=goal.textContent.toLowerCase();let key='focus';if(/stress|anxiety|calm|relax/.test(label))key='stress';else if(/sleep/.test(label))key='sleep';else if(/peak|sport|performance/.test(label))key='performance';else if(/brain|biohack|memory|cognitive/.test(label))key='brain';else if(/depress|trauma|ptsd|addict/.test(label))key='personalized';window.location.assign(document.documentElement.dataset['ih'+key.charAt(0).toUpperCase()+key.slice(1)+'Route']||'/#ih-service-'+key);return;}
    const menu = event.target.closest('[data-ih-menu-trigger]');
    if (menu && !event.target.closest('.ih-myndlift-menu-panel a')) {const panel = menu.querySelector('.ih-myndlift-menu-panel');if(panel){panel.hidden=!panel.hidden;menu.setAttribute('aria-expanded',String(!panel.hidden));}return;}
  });
  document.addEventListener('keydown', event => {
    if (!['Enter',' '].includes(event.key)) return;
    const node = event.target.closest(selector + ' [role="button"], '+selector+' [role="tab"]');
    if (node) {event.preventDefault();node.click();}
  });
  document.addEventListener('visibilitychange',()=>{
    activeVideos.forEach(video=>{
      if (document.hidden) video.pause();
      else if (visible.get(video) && !reduced.matches && video.dataset.ihMyndliftAutoplay==='true') {video.muted=true;const play=video.play();if(play&&play.catch)play.catch(()=>{});}
    });
  });
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>prepare(document),{once:true});
  else prepare(document);
  document.addEventListener('shopify:section:load',event=>prepare(event.target));
})();
